module.exports = __webpack_public_path__ + "d664201f/img/comment-question-icon.7dd26e04.svg";